/// <reference path="../modelyn/dist/modelyn.d.ts" />

// Shared Lit globals and decorators for components using external Lit (loaded globally via modelyn.js)
// This avoids duplicating boilerplate in each component file.

import type { CSSResult, TemplateResult } from 'lit';
import type { PropertyDeclaration } from 'lit-element';

// Type the window globals
type LitElementType = typeof import('lit-element').LitElement;
const _w = window as unknown as {
	html: (strings: TemplateStringsArray, ...values: unknown[]) => TemplateResult;
	css: (strings: TemplateStringsArray, ...values: unknown[]) => CSSResult;
	LitElement: LitElementType;
	unsafeHTML: typeof import('lit/directives/unsafe-html.js').unsafeHTML;
	litRef: typeof import('lit/directives/ref.js').ref;
	styleMap: typeof import('lit-html/directives/style-map.js').styleMap;
};

// Re-export global Lit references (Lit is loaded globally in modelyn.js)
export const html = _w.html;
export const css = _w.css;
export const LitElement = _w.LitElement;
export const unsafeHTML = _w.unsafeHTML;
export const litRef = _w.litRef;
export const styleMap = _w.styleMap;

// Decorator: @customElement('tag-name')
export function customElement(tagName: string) {
	return (target: LitElementType) => { customElements.define(tagName, target); };
}

// Decorator: @property({ type: String })
export function property(options?: PropertyDeclaration) {
	return (target: object, propertyKey: string) => {
		const ctor = target.constructor as LitElementType;
		if (!Object.prototype.hasOwnProperty.call(ctor, 'properties')) {
			(ctor as any).properties = { ...(ctor as any).properties };
		}
		(ctor as any).properties[propertyKey] = options || {};
	};
}

// Decorator: @state() - shorthand for internal reactive state
export function state() {
	return property({ state: true });
}
